/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckGeneralErrorCode {
    NOT_FOUND = 'NOT_FOUND',
    BAD_REQUEST = 'BAD_REQUEST',
    BOOKING_CURRENTLY_NOT_PROCESSABLE = 'BOOKING_CURRENTLY_NOT_PROCESSABLE',
    BOOKING_NOT_PROCESSABLE = 'BOOKING_NOT_PROCESSABLE',
    SESSION_IS_LOCKED = 'SESSION_IS_LOCKED',
    SESSION_FINALISED = 'SESSION_FINALISED'
}


export function instanceOfPaxCheckGeneralErrorCode(value: any): boolean {
    for (const key in PaxCheckGeneralErrorCode) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckGeneralErrorCode, key)) {
            if (PaxCheckGeneralErrorCode[key as keyof typeof PaxCheckGeneralErrorCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckGeneralErrorCodeFromJSON(json: any): PaxCheckGeneralErrorCode {
    return PaxCheckGeneralErrorCodeFromJSONTyped(json, false);
}

export function PaxCheckGeneralErrorCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckGeneralErrorCode {
    return json as PaxCheckGeneralErrorCode;
}

export function PaxCheckGeneralErrorCodeToJSON(value?: PaxCheckGeneralErrorCode | null): any {
    return value as any;
}

export function PaxCheckGeneralErrorCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckGeneralErrorCode {
    return value as PaxCheckGeneralErrorCode;
}

